import React, { useRef } from 'react'
import TawkMessengerReact from '@tawk.to/tawk-messenger-react'

import OrbitSession from '../../hooks/useCookies'

const TawkMsgr = () => {
  const tawkMsgrRef = useRef()

  const onLoad = () => {
    tawkMsgrRef?.current?.setAttributes({
      name: OrbitSession.get('userName'),
      email: OrbitSession.get('email')
    })
  }

  return (
    <TawkMessengerReact
      propertyId='62d3bd40b0d10b6f3e7cb8d1'
      widgetId='1g85hmi67'
      onLoad={onLoad}
      ref={tawkMsgrRef}
    />
  )
}

export default TawkMsgr
